import { render, staticRenderFns } from "./BarsGraph.vue?vue&type=template&id=54ca5b57&"
import script from "./BarsGraph.vue?vue&type=script&lang=ts&"
export * from "./BarsGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports